import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/wkCommon";
import FolderTreeNode from "./FolderTreeNode";
import FolderActions from "./FolderActions";

function buildTree(flat) {
  const map = {};
  const roots = [];

  // clone dulu
  flat.forEach(f => {
    map[f.id] = {
      ...f,
      children: []
    };
  });

  flat.forEach(f => {
    const parent = f.document_folder;

    if (parent && parent.id && map[parent.id]) {
      map[parent.id].children.push(map[f.id]);
    } else {
      roots.push(map[f.id]);
    }
  });

  return roots;
}

export default function FolderTree({ user, activeFolder, onSelect }) {
  const [tree, setTree] = useState([]);

  async function reload() {
    const res = await apiFetch(
      "/api/document-folders?populate[0]=document_folder&populate[1]=allowed_roles&sort=name:asc"
    );
    setTree(buildTree(res.data || []));
  }

  useEffect(() => {
    reload();
  }, []);

  return (
    <div>
      <FolderActions user={user} folder={activeFolder} onChanged={reload} />
      {tree.map(f => (
        <FolderTreeNode
          user={user}
          key={f.documentId}
          folder={f}
          activeFolder={activeFolder}
          onSelect={onSelect}
          level={0}
        />
      ))}
    </div>
  );
}
